import { useEffect, useState } from 'react';

import { AddBomPartsToQuoteSteps } from './AddBomPartsToQuoteSteps';
import { AddBomPartsToQuoteProvider } from './state';
import { IAddBomPartsToQuoteProps } from './types';

export const AddBomPartsToQuote = <TFormData,>({
  addToQuoteType,
  onClose,
  onSubmitSuccess,
  selectedItems,
  sourceQuote,
  entityType,
  mapperFunction,
  addToCustomerQuoteAction,
  addToVendorQuoteAction,
  cliJobInProgressMessageKey,
  cliJobSuccessMessageKey,
  itemsToCopyProps,
}: IAddBomPartsToQuoteProps<TFormData>) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(!!addToQuoteType);
  }, [addToQuoteType]);

  const handleOnClose = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <AddBomPartsToQuoteProvider>
      <AddBomPartsToQuoteSteps
        isOpen={isOpen}
        addToQuoteType={addToQuoteType}
        onClose={handleOnClose}
        onSubmitSuccess={onSubmitSuccess}
        selectedItems={selectedItems}
        sourceQuote={sourceQuote}
        entityType={entityType}
        mapperFunction={mapperFunction}
        addToCustomerQuoteAction={addToCustomerQuoteAction}
        addToVendorQuoteAction={addToVendorQuoteAction}
        cliJobInProgressMessageKey={cliJobInProgressMessageKey}
        cliJobSuccessMessageKey={cliJobSuccessMessageKey}
        itemsToCopyProps={itemsToCopyProps}
      />
    </AddBomPartsToQuoteProvider>
  );
};
